import React, { useState } from 'react'
import { Button, Grid, TextField } from '@material-ui/core'
import { ButtonTab, ButtonTabsContainer } from 'components/Mobile/ButtonTabs'
import CommentItem from 'components/Mobile/CommentItem'
import { LoaderBackdrop } from 'asterX-UI/Loaders'

const CommentsTab = ({
  comments,
  tabsList,
  onAddComment = async (data, cb) => {}
}) => {
  const [activeTab, setActiveTab] = useState('COMMENTS')
  const [comment, setComment] = useState('')
  const [loading, setLoading] = useState(false)
  //result,comments,missing,finservice

  const clearComment = () => {
    setComment('')
  }
  const onChangeComment = e => {
    setComment(e.target.value)
  }
  const onAdd = async () => {
    setLoading(true)
    await onAddComment({ type: activeTab, text: comment }, clearComment)
    setLoading(false)
  }

  const filterByActiveTab = comment => {
    switch (activeTab) {
      case 'COMMENTS':
        return true
      case '@result':
        return (
          comment.type === 'CS_ISSUANCE_CAR' ||
          comment.type === 'CS_ISSUE' ||
          comment.type === 'CS_MEET_CLIENT' ||
          comment.type === 'CS_CALL_CLIENT' ||
          comment.type === '@result'
        )
      case 'MISSING':
        return comment.type === '@close:' || comment.type === 'MISSING'
      case 'FINSERVICE':
        return comment.type === 'FINSERVICE'
      default:
        return false
    }
  }

  const data = comments?.filter(filterByActiveTab)

  return (
    <Grid item container xs={12} md={12} spacing={2}>
      <LoaderBackdrop loading={loading} />
      <Grid item xs={12} md={12}>
        <ButtonTabsContainer>
          {tabsList.map((type, index) => (
            <ButtonTab
              key={`tab_${index}`}
              value={type.value}
              isActive={activeTab === type.value}
              onClick={() => setActiveTab(type.value)}
            >
              {type.label}
            </ButtonTab>
          ))}
        </ButtonTabsContainer>
      </Grid>
      <Grid item xs={12} md={12}>
        {data?.map((comment, index) => (
          <CommentItem
            comment={comment}
            key={`comment_${index}`}
            isLast={data?.length === index}
          />
        ))}
      </Grid>
      {activeTab === 'COMMENTS' && (
        <>
          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              multiline
              minRows={5}
              value={comment}
              label={'Комментарий'}
              onChange={onChangeComment}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Button
              color={'primary'}
              variant={'contained'}
              size={'small'}
              fullWidth
              onClick={onAdd}
            >
              {'Добавить комментарий'}
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  )
}
export default CommentsTab
